var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-8",attrs:{"outlined":_vm.encadre,"elevation":_vm.elevation}},[(_vm.titre)?_c('h3',{staticClass:"text-h5 mb-4"},[_vm._v(" "+_vm._s(_vm.titre)+" ")]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }